interface Node {
  id: string;
  nodes?: Node[];
}

export function findDeepNodeById<T extends Node>(nodes: T[], nodeId: string): T | undefined {
  for (const node of nodes) {
    if (node.id === nodeId) {
      return node;
    }

    if (node.nodes && node.nodes.length > 0) {
      const nestedNode = findDeepNodeById(node.nodes, nodeId);

      if (nestedNode) {
        return nestedNode as T;
      }
    }
  }

  return undefined;
}
